<div class="relative p-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">
      Coordonnées bancaires du gestionnaire de compte
    </h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">IBAN</td>
        <td>
          <iban-input
            [(pays)]="administre.administre_Banque_IBAN"
            [(banque)]="administre.administre_Banque_Code"
            [(guichet)]="administre.administre_Banque_Guichet"
            [(compte)]="administre.administre_Banque_CPT"
            [(cle)]="administre.administre_Banque_CLE"
          ></iban-input>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Guichet</td>
        <td>
          <select-banque
            [(ngModel)]="administre.administre_Banque_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-banque>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Libellé du compte</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Banque_LIB"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Mode de règlement</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select [(ngModel)]="administre.administre_ModeReg">
              <mat-option [value]="0">Chèque</mat-option>
              <mat-option [value]="1">Virement</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
